
<script>
import firebase from '../firebase';
import { onMount } from 'svelte';
import * as user from '../user.js';
import * as utils from '../utils';
import { link, querystring, push, replace } from 'svelte-spa-router'
import { writable } from 'svelte/store';
import { FormValidator, InputValidator } from '../form.js';
import qs from 'qs';
import Header from './header.svelte';
import Button from './button.svelte';


let oldPassword = '';
let newPassword = '';

let email = '';
let oobCode = '';
let error = '';

let state = '';
let setting = false;
let passwordError = false;
$:setButtonState = setting ? 'loading' : '';

let emailElement = null;

const forcedFormValidator = FormValidator();

/*
Support two main cases here:
    1. This is a user that we are migrating from the old system. After they have signed in we
        will check their user account and if they need to reset their password we will redirect them here
        Display some message about needing to set a password

    2. During sign in we will have a forgot password link that will send them an email. When they open the email
        we will confirm the code is valid, and then redirect them to this page to set a password

*/

// Dumb but I needed to slow down a state change to see what was happening and so I just left it
function SetState(newState)
{
    state = newState;
    //setTimeout(() => { state = newState; }, 300);
}

function SendEvent(elem, eventName) {
    //Needed for IE Support: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/dispatchEvent#Browser_Compatibility
    //https://stackoverflow.com/a/49071358/79677
    let event;
    if (typeof(Event) === 'function') {
        event = new Event(eventName);
    } else {
        event = document.createEvent('Event');
        event.initEvent(eventName, true, true);
    }

    elem.dispatchEvent(event);

    return event;
};

onMount(() =>
{
    const params = qs.parse($querystring);

    // if this was a reset that came from an email
    if (params.oobCode)
    {
        oobCode = params.oobCode;
        firebase.auth().checkActionCode(params.oobCode).then((info) => {
            SetState('ready');
            if (info.operation === 'PASSWORD_RESET')
            {
                email = info.data.email;
                // now we wait for them to change their password
            }
        }).
        catch((e) =>
        {
            console.log('link error', e);
            SetState('error');
        });
    }
    else if (params.forced)
    {
        // get the user. If it fails show a message that tells them to go sign in again and will bring them back here
        SetState('forced');

        // get the user. If it fails show a message that tells them to go sign in again and will bring them back here
        user.Get().then((u) =>
        {
            if (u && u.auth)
            {
                // reset time....
                email = u.email;

                // we do this to force the input validator to update its state and validate the email
                setTimeout(function() { SendEvent(emailElement, 'stupid') }, 1);

                return;
            }

            SetState('signin');
        })
        .catch((e) =>
        {
            console.log('error', e);
            SetState('signin');
        });
    }
});


$:newPasswordButtonState = setting ? 'loading' : '';
function ForcedSetPassword()
{
    if ($forcedFormValidator !== 1)
        return;

    setting = true;

    // first get a new token
    const credential = firebase.auth.EmailAuthProvider.credential(
        email,
        oldPassword
    );


    let authUser = firebase.auth().currentUser;
    if (authUser)
    {
        authUser.reauthenticateWithCredential(credential).then(() =>
        {
            authUser.updatePassword(newPassword).then(() =>
            {
                user.Update(authUser.uid, {forcePasswordReset:false});
                state = 'done';
            })
            .catch((e) =>
            {
                utils.error('Error updating user password', e);

                if (e.code === 'auth/requires-recent-login')
                {
                    // this really shouldn't happen;
                    //SetState('signin');
                }
                else if (e.code === 'auth/weak-password')
                {
                    // TODO. We should catch this automatically
                }
            })
            .then(() =>
            {
                setting = false;

            });

        })
        .catch((e) =>
        {
            console.log('error', e);
            if (e.code === 'auth/wrong-password')
            {
                error = 'Your current password is not correct. Please try again';
            }
        })
        .then(() =>
        {
            setting = false;
        });
    }
    else
    {
        // uh....
    }

}

function SetPassword()
{

    setting = true;
    firebase.auth().confirmPasswordReset(oobCode, newPassword).then((resp) =>
    {
        SetState('done');
    })
    .catch((e) =>
    {
        if (e.code === 'auth/weak-password')
        {
            passwordError = true;
        }
        else
        {
            // for anything else I think we just show an expired error
            SetState('error');
        }
        //console.log("password reset error", e);
    })
    .then(() =>
    {
        setting = false;
    });
}

</script>

<Header/>

<!-- Section -->
<div class="container main medium" style="margin-top: 2.5em;">
  <section>
    {#if state === 'error'}
        <header>
            <h3>
            Oops. It looks like this link has expired.
            </h3>
            <p>If you are tring to reset your password, <a href="/signinhelp" use:link>click here to try again</a></p>
        </header>
        <p>If you are having issues <a href="/contact" use:link>contact support</a></p>

    {:else if state === 'ready'}
      <header class="line-after">
          <h3>Reset your password</h3>
        </header>
        <form on:submit|preventDefault={SetPassword} novalidate>
            <div class="row gtr-uniform gtr-50">
                {#if error}
                <div class="col-12 col-12-xsmall">
                    <ul class="actions special">
                        <li class="error"><div>{error}</div></li>
                    </ul>
                </div>
                {/if}
                <div class="col-12 col-12-xsmall">
                    <p>For: {email}</p>
                </div>

                <div class="col-12 col-12-xsmall">
                    <input type="password" placeholder="Password (6+ characters)" bind:value={newPassword} />
                    {#if passwordError}
                    <div class="errorMsg error">Use a password with at least 6 characters</div>
                    {/if}
                </div>
                <div class="col-12 col-12-xsmall">
                    <ul class="actions special">
                        <li><Button state={setButtonState} class="primary button fit" text="Set"/></li>
                            <li><button class="button fit" disabled={setting}>Cancel</button>
                    </ul>
                </div>
            </div>
        </form>
    {:else if state === 'forced'}
        <header class="line-after">
            <h3>Your password has expired and needs to be changed</h3>
        </header>
        <form on:submit|preventDefault={ForcedSetPassword} novalidate>
            <div class="row gtr-uniform gtr-50">
                {#if error}
                <div class="col-12 col-12-xsmall">
                    <ul class="actions special">
                        <li class="error"><div>{error}</div></li>
                    </ul>
                </div>
                {/if}
                <div class="col-12 col-12-xsmall">
                    <input use:InputValidator={forcedFormValidator} bind:this={emailElement} type="email" placeholder="Email" bind:value={email} />
                </div>
                <div class="col-12 col-12-xsmall">
                    <label for="currentPassword">Current Password</label>
                    <input use:InputValidator={forcedFormValidator} name="currentPassword" type="password" placeholder="Current Password" bind:value={oldPassword} />
                    <div class="errorMsg">Enter you current password</div>
                </div>
                <div class="col-12 col-12-xsmall">
                    <label for="currentPassword">New Password</label>
                    <input use:InputValidator={forcedFormValidator} type="password" placeholder="New Password (6+ characters)" bind:value={newPassword} />
                    <div class="errorMsg">Use a password with at least 6 characters</div>
                </div>
                <div class="col-12 col-12-xsmall">
                    <ul class="actions special">
                        <li><Button state={newPasswordButtonState} class="button fit primary" text="Set"/></li>
                    </ul>
                </div>
            </div>
        </form>
    {:else if state === 'signin'}
        <header>
            <h3>
            To reset your password please Sign In first.
            </h3>
            <div class="button fit" style="color: #fff" on:click={() => { utils.RequestSignIn('/reset', $querystring); }}>Sign In</div>
        </header>

    {:else if state === 'done'}
        <header>
            <h3>
            Your password has been reset
            </h3>
            <div class="button fit" style="color: #fff" on:click={() => { replace('/signin') }}>Sign In</div>
        </header>
    {:else}
        <h2 style="text-align:center">
            Loading....
            <div class="spinner"></div>
        </h2>
    {/if}
    </section>
</div>

<style>
label
{
    color: white;
}

header.major { margin: 1em 0 0 0; }
header.line-after:after {
  content: '';
  display: inline-block;
  width: 100%;
  height: 0.25rem;
  margin: 0em 0 1.5em 0;
  border-radius: 4px;
  background-color: #4a98e2;
}

@media screen and (max-width: 480px) {
  .container > section.line-after:after {
    width: 100%;
    height: 0.25rem;
    margin: 1em 0;
  }
}

@media screen and (max-width: 736px) {
  .image > img {
    max-width: 90%;
    margin: 0 auto;
  }
}

form a
{
    color: rgb(103, 189, 255);
    border-bottom: 0;
}
.errorMsg
{
    color: red;
    text-align: left;
}

input.error
{
    border-color: red;
    border-width: 2px;
}

.container.medium.main {
  background-color: #1a242f !important;
  padding-top: 0;
  font-size: 13pt;
}

.container.medium.main input, .button.fit {
    background-color: rgb(0 0 0 / .3);
}

.container.medium.main h4, .container.medium.main h6, input, label, h2, h3, p, .button.fit {
  color: #fff !important;
}

label {font-weight: 400;}

.container.medium.main {
  width: 500px;
  max-width: 500px;
}

@media screen and (max-width: 736px) {
  .container.medium.main {
    width: 425px;
  }
}

@media screen and (max-width: 480px) {
  .container.medium.main {
    width: 275px;
  }
}

@media screen and (max-width: 320px) {
  .container.medium.main {
    width: 250px;
  }
}


ul.actions.special >li { width: 100%; margin: 0;}


span.error
{
    color: red;
}

input.error
{
    border-color: red;
}

.errorMsg
{
    padding-left:10px;
    display:none;
}

li.error
{
    width: 100%;
    color: red;
}


</style>
